<template>
    <div class="grid" >
    <div class="col-12 md-12 lg-12">
      <Bilgiler />
    </div>

    <div class="col-12 md-12 lg-12">
    </div>

    <div class="col-12 md-12 lg-12">
    </div>

  </div>


</template>

<script>
// import GlobalServis from "../../../services/GlobalServis";
import Bilgiler from "./Bilgiler.vue";
// import SatisGrafik from "./SubComponents/SatisGrafik.vue";
export default {
  data() {
    return {
    };
  },
  methods: {

  },
  mounted() {
    
  },
  components: {
    Bilgiler,
    // SatisGrafik
  },
};
</script>